module.exports = __webpack_public_path__ + "static/media/short-hit.9525b282.png";